import { createAppMainStore } from "shared-ui/stores/create-app-main-store";
import { useAuthStore } from "@/stores/auth-store";

export const useMainStore = createAppMainStore("frontend-main", useAuthStore);
